module.exports = __webpack_public_path__ + "img/5分钟用AIicon.c4899a2b.png";